// eslint-disable-next-line no-restricted-syntax
export enum AppLocale {
  en = 'en',
  fr = 'fr',
  'es-419' = 'es-419',
}
